import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";
import Pagination from "../../../shared/Pagination";
import {
  searchExpensePills,
  toggleColumns,
} from "../../../mock/SearchExpenses";
import SearchExpenseTable from "./SearchExpenseTable";
import SearchExpenseForm from "./SearchExpenseForm";

const SearchExpenses = () => {
  const [toggleFilters, setToggleFilters] = useState(true);

  const handleToogleFilters = () => {
    setToggleFilters(!toggleFilters);
  };

  return (
    <DashboardLayout>
      <div className="mb-4 p-0 p-sm-3">
        <div className="section_top d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center my-3">
          <div className="mb-3 mb-md-0">
            <h2 className="my-2 me-3 d-inline-block">
              <span>Search Expenses</span>
            </h2>
            <button
              className="btn site_btn text-white my-2 me-2"
              onClick={handleToogleFilters}
            >
              Toggle Filters
            </button>

            <div className="dropdown d-inline-block my-2 me-2">
              <button
                className="btn btn-primary dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Toggle Columns
              </button>
              <ul
                className="dropdown-menu p-2"
                aria-labelledby="dropdownMenuButton1"
              >
                <input
                  type="text"
                  name="search"
                  className="form-control px-2 mb-2"
                  id="search"
                  placeholder="Search columns"
                />
                {toggleColumns.map((item, index) => (
                  <li className="dropdown-item" key={index}>
                    {item.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="d-flex align-items-center mt-2 mt-md-0">
            <span className="me-2">Items Per Page</span>
            <input
              type="number"
              name="item_number"
              value="20"
              className="form-control w-50"
              disabled
            />
          </div>
        </div>

        <SearchExpenseForm toggleFilters={toggleFilters} />

        <Pagination />

        <div className="d-block d-sm-flex justify-content-between my-4">
          <div>
            {searchExpensePills.map((item) => (
              <button
                className={`mb-2 ms-2 btn btn-${item.variant} wt-disable-link`}
                key={item.id}
              >
                {item.title}
                <span className="badge badge-pill badge-light mx-2">
                  {item.value}
                </span>
              </button>
            ))}
          </div>
          <button className="btn btn-outline-primary mb-2 mr-2 btn btn-outline-primary page-title-action">
            Export
          </button>
        </div>

        <SearchExpenseTable />

        <Pagination />
      </div>
    </DashboardLayout>
  );
};

export default SearchExpenses;
